/**
 * Sources > Default > Vendors: Iframe Resizer
 */

import SelectorEngine from '../../../shared/dom/selector-engine';
import Manipulator    from '../../../shared/dom/manipulator';

import iframeResizer from 'iframe-resizer/js/iframeResizer';

// -------
// Private
// -------

const lastHeights = new WeakMap();

const DEFAULTS = {
	license: 'GPLv3',
	checkOrigin: [
		'https://shop.krystallpalast.de',
		'https://shop.vineta-stoermthal.de'
	],
	waitForLoad: true,
	direction: 'vertical',
	scrolling: false,
	warningTimeout: 10000,
	onResized: ({iframe, height}) => {
		const previous = lastHeights.get(iframe) ?? height;
		lastHeights.set(iframe, height);

		const shrinkAmount = previous - height;
		const isLargeShrink = shrinkAmount > 2000;

		if (!isLargeShrink) {
			return;
		}

		if (iframe.id === 'tickets_iframe') {
			const header = document.querySelector('#page-header'); // Selector anpassen
			const headerOffset = header ? header.getBoundingClientRect().height : 0;
			const iframeTop = iframe.getBoundingClientRect().top + window.pageYOffset;
			const targetY = Math.max(0, iframeTop - headerOffset - 8); // 8px Luft optional

			window.scrollTo({top: targetY, behavior: 'smooth'});
		}
	}
};
let group = [];

// -------
// Public
// -------

const init = () => {
	const COLLECTION = SelectorEngine.find('iframe[data-resize]');

	if(!COLLECTION.length) return;

	for(const element of COLLECTION) {
		group.push(iframeResizer(DEFAULTS, element));
	}
};

// -------
// Export
// -------

export default init;